/**
 * @generated SignedSource<<ad02dc5a9b4795d4cd21eb1aed46c501>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AddRowInput = {
  clientMutationId?: string | null;
  elementId: string;
  position?: number | null;
};
export type GridQuestionEditor_addRow_Mutation$variables = {
  input: AddRowInput;
};
export type GridQuestionEditor_addRow_Mutation$data = {
  readonly addRow: {
    readonly element: {
      readonly gridAnswers: ReadonlyArray<{
        readonly answer: {
          readonly dbId: string;
          readonly id: string;
        };
        readonly goal: number | null;
        readonly row: {
          readonly dbId: string;
          readonly id: string;
          readonly position: number;
        };
        readonly terminate: boolean | null;
      } | null> | null;
      readonly id: string;
      readonly rows: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly dbId: string;
            readonly id: string;
            readonly position: number;
            readonly text: string;
          } | null;
        } | null>;
      };
    } | null;
  } | null;
};
export type GridQuestionEditor_addRow_Mutation = {
  response: GridQuestionEditor_addRow_Mutation$data;
  variables: GridQuestionEditor_addRow_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dbId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "position",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "RowNodeConnection",
  "kind": "LinkedField",
  "name": "rows",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RowNodeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RowNode",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            (v3/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "text",
              "storageKey": null
            },
            (v4/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "RowNode",
  "kind": "LinkedField",
  "name": "row",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/),
    (v4/*: any*/)
  ],
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "AnswerNode",
  "kind": "LinkedField",
  "name": "answer",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/)
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "goal",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "terminate",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GridQuestionEditor_addRow_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AddRowPayload",
        "kind": "LinkedField",
        "name": "addRow",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ElementNode",
            "kind": "LinkedField",
            "name": "element",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "GridAnswerNode",
                "kind": "LinkedField",
                "name": "gridAnswers",
                "plural": true,
                "selections": [
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GridQuestionEditor_addRow_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AddRowPayload",
        "kind": "LinkedField",
        "name": "addRow",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ElementNode",
            "kind": "LinkedField",
            "name": "element",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "GridAnswerNode",
                "kind": "LinkedField",
                "name": "gridAnswers",
                "plural": true,
                "selections": [
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "de7d12b12df807a27e14aece24be6cf0",
    "id": null,
    "metadata": {},
    "name": "GridQuestionEditor_addRow_Mutation",
    "operationKind": "mutation",
    "text": "mutation GridQuestionEditor_addRow_Mutation(\n  $input: AddRowInput!\n) {\n  addRow(input: $input) {\n    element {\n      id\n      rows {\n        edges {\n          node {\n            id\n            dbId\n            text\n            position\n          }\n        }\n      }\n      gridAnswers {\n        row {\n          id\n          dbId\n          position\n        }\n        answer {\n          id\n          dbId\n        }\n        goal\n        terminate\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "59cc3e9e462e04afe07c4f6abf0e4977";

export default node;
